module.exports = " <li class=\"side-menu-list__item icon-admin-white\" :class=icon v-if=\"adminUrl !== ''\"> <a target=_blank :href=adminUrl class=side-menu-list__icon></a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/navigation/sidebar/SidebarAdministration.vue
// module id = 165
// module chunks = 0